/**
 * Resolve the live-tour target in the real DOM.
 * Duplicate data-tour-id attributes exist (desktop + mobile nav, etc.).
 * Always prefer a visible, on-screen node so the tour does not attach to a
 * hidden copy and appear to skip or overlap the wrong panel.
 */

function isDisplayed(el) {
  if (!el || el.nodeType !== 1) return false;
  const style = window.getComputedStyle(el);
  if (
    style.display === "none" ||
    style.visibility === "hidden" ||
    Number(style.opacity) === 0
  ) {
    return false;
  }
  if (el.getAttribute("aria-hidden") === "true") return false;
  if (el.closest('[aria-hidden="true"]')) return false;
  const rect = el.getBoundingClientRect();
  return rect.width >= 2 && rect.height >= 2;
}

function viewportScore(rect) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const visibleW = Math.max(
    0,
    Math.min(rect.right, vw) - Math.max(rect.left, 0),
  );
  const visibleH = Math.max(
    0,
    Math.min(rect.bottom, vh) - Math.max(rect.top, 0),
  );
  return visibleW * visibleH;
}

export function findTourTarget(targetId) {
  if (!targetId || typeof document === "undefined") return null;
  const nodes = document.querySelectorAll(`[data-tour-id="${targetId}"]`);
  if (!nodes.length) return null;

  const usable = [];
  nodes.forEach((el) => {
    if (isDisplayed(el)) usable.push(el);
  });
  const pool = usable.length ? usable : Array.from(nodes);
  if (!pool.length) return null;

  let best = pool[0];
  let bestScore = -1;
  pool.forEach((el) => {
    const score = viewportScore(el.getBoundingClientRect());
    if (score > bestScore) {
      best = el;
      bestScore = score;
    }
  });
  return best;
}

/** Spotlight only the on-screen slice of a large target (sidebar, form). */
export function clipRectToViewport(rect) {
  if (!rect) return null;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const top = Math.max(rect.top, 8);
  const left = Math.max(rect.left, 8);
  const right = Math.min(rect.left + rect.width, vw - 8);
  const bottom = Math.min(rect.top + rect.height, vh - 8);
  const width = right - left;
  const height = bottom - top;
  if (width < 8 || height < 8) return rect;
  return { top, left, width, height };
}
